import { Table } from "@tanstack/react-table";
import { useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";
import { Button } from "@/components/ui/button/button";
import { Textarea } from "@/components/ui/textarea/textarea";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";
import { Input } from "@/components/ui/input/input";

interface AddComponentProps<TData> {
  table: Table<TData>;
}

export const AddSalaryComponent = <TData,>({
  table,
}: AddComponentProps<TData>) => {
  const [open, setOpen] = useState(false);

  const [rowData, setRowData] = useState({
    type: "",
    name: "",
    amount: 0,
    description: "",
  });

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>
          <Button type="button" size="sm">
            Add Component
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="max-w-xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="tracking-normal">
              Add Component
            </AlertDialogTitle>
          </AlertDialogHeader>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="type">Type</label>
              <Select
                value={rowData.type}
                onValueChange={(value) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      type: value,
                    };
                  });
                }}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="component type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Earning">Earning</SelectItem>
                  <SelectItem value="Deduction">Deduction</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="name">Name</label>
              <Input
                id="name"
                name="name"
                value={rowData.name}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="amount">Amount</label>
              <Input
                id="amount"
                name="amount"
                value={rowData.amount}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="description">Description</label>
              <Textarea
                id="description"
                name="description"
                value={rowData.description}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>
          </div>

          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // @ts-ignore
                table.options.meta?.addRow(rowData);

                setRowData({
                  description: "",
                  type: "",
                  amount: 0,
                  name: "",
                });

                setOpen(false);
              }}
            >
              Add
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
